// App.js

import React, { useState, useEffect } from "react";
import "./App.css";
import Logo from "./images/borderpal.png";
import Weather from "./components/Weather";
import About from "./components/About";
import WaitTimes from "./components/WaitTimes";
import GasCalculator from "./components/GasCalculator";
import FuelTool from "./components/FuelTool";
import CurrencyConverter from "./components/CurrencyConverter";
import Map from "./components/Map";
import Preferences from "./components/Preferences";
import TollRates from "./components/TollRates";

function App() {
  const [consented, setConsented] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [currentView, setCurrentView] = useState("dashboard");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("analyticsConsent");
    if (consent === null) {
      setShowBanner(true);
    } else {
      setConsented(consent === "accepted");
    }
  }, []);

  useEffect(() => {
    window.consented = consented;
  }, [consented]);

  const handleAccept = () => {
    localStorage.setItem("analyticsConsent", "accepted");
    setConsented(true);
    setShowBanner(false);
    if (window.gtag)
      window.gtag("event", "consent_granted", { consent_type: "analytics" });
  };

  const handleDecline = () => {
    localStorage.setItem("analyticsConsent", "declined");
    setConsented(false);
    setShowBanner(false);
    if (window.gtag)
      window.gtag("event", "consent_denied", { consent_type: "analytics" });
  };

  const renderView = () => {
    switch (currentView) {
      case "about":
        return <About />;
      case "preferences":
        return <Preferences />;
      case "fueltool":
        return <FuelTool />;
      case "tollrates":
        return <TollRates />;
      case "dashboard":
      default:
        return (
          <div>
            <WaitTimes />
            <GasCalculator />
            <Weather />
            <CurrencyConverter />
            <Map />
          </div>
        );
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-content">
          <img src={Logo} alt="BorderPal Logo" className="logo" />
          <h1>BorderPal</h1>
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </button>
        </div>
        <p style={{ margin: "0", fontStyle: "italic" }}>
          Utility for Windsor-Detroit Border Crossers
        </p>
      </header>
      {showBanner && (
        <div className="consent-banner">
          <p>Help us improve BorderPal with anonymous analytics?</p>
          <div className="buttons">
            <button onClick={handleAccept}>Accept</button>
            <button onClick={handleDecline}>Decline</button>
          </div>
        </div>
      )}
      <nav className={`nav ${menuOpen ? "open" : ""}`}>
        <button
          onClick={() => {
            setCurrentView("dashboard");
            setMenuOpen(false);
            if (window.gtag && window.consented)
              window.gtag("event", "page_view", { page: "dashboard" });
          }}
        >
          Dashboard
        </button>
        <button
          onClick={() => {
            setCurrentView("fueltool");
            setMenuOpen(false);
            if (window.gtag && window.consented)
              window.gtag("event", "page_view", { page: "fuel_tool" });
          }}
        >
          Fuel Tool
        </button>
        <button
          onClick={() => {
            setCurrentView("preferences");
            setMenuOpen(false);
            if (window.gtag && window.consented)
              window.gtag("event", "page_view", { page: "preferences" });
          }}
        >
          Preferences
        </button>
        <button
          onClick={() => {
            setCurrentView("tollrates");
            setMenuOpen(false);
            if (window.gtag && window.consented)
              window.gtag("event", "page_view", { page: "toll_rates" });
          }}
        >
          Toll Rates
        </button>
        <button
          onClick={() => {
            setCurrentView("about");
            setMenuOpen(false);
            if (window.gtag && window.consented)
              window.gtag("event", "page_view", { page: "about" });
          }}
        >
          About
        </button>
      </nav>
      {menuOpen && (
        <div className="nav-overlay" onClick={() => setMenuOpen(false)}></div>
      )}
      <main>{renderView()}</main>
      <footer>
        <a
          href="https://www.buymeacoffee.com/boneseh"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://cdn.buymeacoffee.com/buttons/bmc-new-btn-logo.svg"
            alt="Buy Me a Coffee"
          />
          Buy me a coffee
        </a>
      </footer>
    </div>
  );
}

export default App;
